var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "white",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_654_37426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 7.29276 4.28095 6.61448 4.78105 6.11438C5.28115 5.61429 5.95942 5.33334 6.66667 5.33334H13.3333C14.0406 5.33334 14.7189 5.61429 15.219 6.11438C15.719 6.61448 16 7.29276 16 8V12C16 12.7072 15.719 13.3855 15.219 13.8856C14.7189 14.3857 14.0406 14.6667 13.3333 14.6667H6.66667C5.95942 14.6667 5.28115 14.3857 4.78105 13.8856C4.28095 13.3855 4 12.7072 4 12V8Z",
    fill: "#00938A",
    stroke: "#00938A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9L11 10L9 11V9Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_37426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.1dc84c1fcd24bf866db483ed6199a568.svg";
export { ForwardRef as ReactComponent };